import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import styles from './tag.module.scss';

export default function Tag({ label = '' }) {
  return <span className={styles.tag}>{parse(label)}</span>;
}

Tag.propTypes = {
  label: PropTypes.string,
};
